import { StoreState } from '@/core/models/store.interface';
import store from '@/core/store';
import { Module } from 'vuex';
import { ApiPatch } from './../../models/api-patch.interface';
import { UserInfo } from './user-info.interface';
import { UserInfoService } from './user-info.service';

const userInfoService = new UserInfoService();

export interface UserInfoState {
   userInfo?: UserInfo;
   loadingUserInfo: boolean;
}

const UserStore: Module<UserInfoState, StoreState> = {
   namespaced: true,
   state: {
      loadingUserInfo: true,
   },
   getters: {
      userInfo: (state) => state.userInfo,
   },
   mutations: {
      SET_USER_INFO(state, userInfo?: UserInfo) {
         state.userInfo = userInfo;
      },
      SET_LOADING_USER_INFO(state: UserInfoState, loading: boolean) {
         state.loadingUserInfo = loading;
      },
   },
   actions: {
      async getUserInfo(context) {
         context.commit('SET_LOADING_USER_INFO', true);

         try {
            const userInfo = await userInfoService.getUserInfo();
            context.commit('SET_USER_INFO', userInfo);
            store.commit('communication/messages/UPDATE_UNREAD_MESSAGES', userInfo?.default_team?.unread_messages || 0);
            context.commit('SET_LOADING_USER_INFO', false);
            return userInfo;
         } catch (ex: any) {
            context.commit('SET_LOADING_USER_INFO', false);
            throw ex;
         }
      },
      async changeUserInfo(context, userInfoPatchData: ApiPatch) {
         const userInfo = await userInfoService.patchUserInfo(userInfoPatchData);
         context.commit('SET_USER_INFO', userInfo);
         store.commit('communication/messages/UPDATE_UNREAD_MESSAGES', userInfo.default_team.unread_messages || 0);
         return userInfo;
      },
   },
};

export default UserStore;
